import { Action } from "redux";

export interface IOpenFormIconEditAction extends Action<string> {
    readonly payload: {
        readonly id: string;
    };
}

export class IOpenFormIconEditAction {
    public static [Symbol.hasInstance](instance: any): string {
        return instance?.payload?.id;
    }
}
